import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView";
import Profile from "../views/Profile.vue";
import TermConditionVuew from "../views/TermCondition.vue";
import Product from "../views/Product";
import Cart from "../views/Cart";
import ProductDeatils from "../views/ProductDeatils";
import Orders from "../views/Orders";
import Checkout from "../views/Checkout";
import DashboardLayout from "../views/dashboard/DashboardLayout";
import ProductOverview from "../views/shop/ProductOverview";
import ProductBrandwise from "../views/shop/ProductBrandwise";
import ProductLayout from "../views/shop/ProductLayout";
import Overview from "../views/dashboard/Overview";
import Products from "../views/dashboard/Products";
import MyProducts from "../views/dashboard/MyProduct.vue";
import Allorders from "../views/dashboard/Orders";
import Login from "../views/Auth/Login.vue";
import ResetPassword from "../views/Auth/ResetPassword.vue";
import AccessDenied from "../views/Auth/AccessDenied.vue";
import NotFound from "../views/Auth/NotFound.vue";
import Signup from "../views/Auth/Signup.vue";
import { useAuthStore } from "@/Stores/authStore";
import DigitalShop from "../views/shop/DigitalShop.vue";
import ProductCategory from "@/views/dashboard/appsettings/ProductCategory";
import ProductBrands from "@/views/dashboard/appsettings/ProductBrands";
import PaymentMethod from "@/views/dashboard/appsettings/PaymentMethod";
import OrderStatus from "@/views/dashboard/appsettings/OrderStatus";
import PaymentStatus from "@/views/dashboard/appsettings/PaymentStatus";
import Agents from "@/views/dashboard/Agents.vue";
import Staff from "@/views/dashboard/Staff.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
  },
  {
    path: "/term&conditions",
    name: "term&conditions",
    component: TermConditionVuew,
  },
  {
    path: "/product",
    name: "product",
    component: ProductLayout,

    children: [
      {
        path: "",
        name: "ProductOverview",
        component: ProductOverview,
      },
      {
        path: "brandwise/:brand_id/:brand_name",
        name: "ProductBrandwise",
        component: ProductBrandwise,
      },
      {
        path: "my-shop",
        name: "my-shop",
        component: DigitalShop,
      },
    ],
  },

  // {
  //   path: "/product",
  //   name: "product",
  //   component: Product,
  // },
  {
    path: "/product-details/:id",
    name: "product-details",
    component: ProductDeatils,
  },
  {
    path: "/cart",
    name: "cart",
    component: Cart,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/order",
    name: "order",
    component: Orders,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/checkout",
    name: "checkout",
    component: Checkout,
    meta:{
      requiresAuth:true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/reset-password",
    name: "Rest",
    component: ResetPassword,
  },
  {
    path: "/signup",
    name: "signup",
    component: Signup,
  },

  {
    path: "/accessdenied",
    name: "accessdenied",
    component: AccessDenied,
  },
  { path: "/:pathMatch(.*)*", name: "not-found", component: NotFound },
  // {
  //   path: "/dashboard-home",
  //   name: "dashboard-home",
  //   component: DashboardHome,
  // },
  // {
  //   path: "/dashboard-home",
  //   name: "dashboard-home",
  //   component: Overview, // Link the Overview component
  // },

  {
    path: "/dashboard",
    name: "dashboard-home",
    component: DashboardLayout,
    meta: {
      requiresAuth: true,
      roles: [1, 2, 3],
    },
    children: [
      {
        path: "",
        name: "Overview",
        component: Overview,
        meta: {
          requiresAuth: true,
          roles: [1, 2, 3],
        },
      },
      {
        path: "products",
        name: "products",
        component: Products,
        meta: {
          requiresAuth: true,
          roles: [1, 2,],
        },
      },
      {
        path: "my-products",
        name: "my-products",
        component: MyProducts,
        meta: {
          requiresAuth: true,
          roles: [1, 2, 3, 4],
        },
      },
      {
        path: "agents",
        name: "agents",
        component: Agents,
        meta: {
          requiresAuth: true,
          roles: [1, 2,],
        },
      },

      {
        path: "staffs",
        name: "staffs",
        component: Staff,
        meta: {
          requiresAuth: true,
          roles: [1],
        },
      },

      {
        path: "orders",
        name: "orders",
        component: Allorders,
        meta: {
          requiresAuth: true,
          roles: [1, 2,],
        },
      },

      {
        path: "categoriies",
        name: "categoriies",
        component: ProductCategory,
        meta: {
          requiresAuth: true,
          roles: [1],
        },
      },
      {
        path: "product-brands",
        name: "product-brands",
        component: ProductBrands,
        meta: {
          requiresAuth: true,
          roles: [1],
        },
      },
      {
        path: "payment-methods",
        name: "payment-methods",
        component: PaymentMethod,
        meta: {
          requiresAuth: true,
          roles: [1],
        },
      },
      {
        path: "payment-statuses",
        name: "payment-statuses",
        component: PaymentStatus,
        meta: {
          requiresAuth: true,
          roles: [1],
        },
      },
      {
        path: "order-statuses",
        name: "order-statuses",
        component: OrderStatus,
        meta: {
          requiresAuth: true,
          roles: [1],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

//auth guard logic
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const token = authStore.token;
  const userRole = authStore.roles;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!token) {
      next({ name: "login" });
    } else {
      const requiredRoles = to.meta.roles || [];

      if (requiredRoles.length === 0 || requiredRoles.includes(userRole)) {
        next();
      } else {
        next({ name: "accessdenied" });
      }
    }
  } else {
    next();
  }
});

export default router;
